import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

export default function ProductDetails(props) {
  const QuoteableTerms = [10, 15, 20, 25, 30, 35, 40];
  const GetTermsString = (terms) => {
    let validTerms = terms.filter((element) => QuoteableTerms.includes(element));
    let termsString = '';
    validTerms.forEach(function (item, index) {
      if (validTerms.length === index + 1) {
        termsString = termsString + 'and ' + item;
      } else {
        termsString = termsString + item + ', ';
      }
    });
    return termsString;
  };
  return (
    <Row>
      <Col sm="6" className="mt-2">
        <span dangerouslySetInnerHTML={{ __html: props.productDescription }} />
      </Col>

      <Col sm="6" className="mt-2">
        <p>
          <strong>Product Information</strong>
        </p>
        <ul dangerouslySetInnerHTML={{ __html: props.productInformation }} />
      </Col>
    </Row>
  );
}

ProductDetails.propTypes = {
  productDescription: PropTypes.string.isRequired,
  hasPermConversion: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/MCT/Helpers/MCTProductDetails.js